import {
  Button,
  EButtonColorVariant,
  EHeadingStyleVariant,
  ETextStyleVariant,
  Heading,
  Text,
} from '@outdoorsyco/bonfire';
import Image from 'next/image';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import RVHero from '@/assets/become-a-host/rv/hero.jpg';
import { useBreakpoint } from '@/hooks/useBreakpoint';

import styles from './BecomeAHost.module.css';
import { useHostingRVFlow } from './RV/useHostingRVFlow';

export const Hero = () => {
  const { isMobile } = useBreakpoint();
  const intl = useIntl();

  const rvContent = {
    title: intl.formatMessage({
      defaultMessage: 'Earn income renting your RV or campervan',
      id: 'OxTSQC',
    }),
    description: intl.formatMessage({
      defaultMessage: 'Sign up for free, host when you want, and get paid every week.',
      id: 'Zhts6P',
    }),
    image: RVHero,
    imageAlt: intl.formatMessage({ defaultMessage: 'RV - Become a host banner', id: 'RrOHlT' }),
  };

  const { redirectToHostingRVFlow, loading } = useHostingRVFlow();

  const handleHostingFlow = () => {
    redirectToHostingRVFlow();
  };

  return (
    <section>
      <div className="bg-canvas-100">
        <div className="px-4 py-20 mx-auto text-center max-w-[42rem]">
          <Text variant={ETextStyleVariant.LegalRegular} className="uppercase">
            <FormattedMessage defaultMessage="BECOME A HOST" id="06MJEL" />
          </Text>
          <Heading
            variant={isMobile ? EHeadingStyleVariant.H2 : EHeadingStyleVariant.H1}
            className="mt-6 mb-10">
            {rvContent.title}
          </Heading>

          {rvContent.description && (
            <Heading variant={EHeadingStyleVariant.H4Alt} className="mt-4 mb-6">
              {rvContent.description}
            </Heading>
          )}

          <div className="flex items-center justify-center mt-4 gap-2">
            <Button
              onClick={handleHostingFlow}
              variant={EButtonColorVariant.Primary}
              label={intl.formatMessage({ defaultMessage: 'Get started', id: '/aBLH2' })}
              loading={loading}
            />
          </div>
        </div>
      </div>

      <div className={styles.heroContainer}>
        <Image
          src={rvContent.image}
          alt={rvContent.imageAlt}
          role="presentation"
          sizes="100vw"
          priority={true}
          width={1139}
          height={629}
          className="rounded-2xl"
        />
      </div>
    </section>
  );
};
